export const socialData = [
    {
        type: "youtube",
        link: "https://www.youtube.com/@DraquioOficial",
    },
    {
        type: "instagram",
        link: "https://www.instagram.com/draquio/",
    },
    {
        type: "linkedin",
        link: "https://www.linkedin.com/in/sergio-mercado-galarza-4a4b42274/",
    }
]